/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ field: NonNullable<unknown> }} Measure_Explainer_ExtraInputs */

const en_measure_explainer_extra = /** @type {((inputs: Measure_Explainer_ExtraInputs) => LocalizedString) & { parts: (inputs: Measure_Explainer_ExtraInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Measure_Explainer_ExtraInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`Off until ${i?.field}: true, then added on top of the cap.`)
		}),
		{
			parts: /** @type {(inputs: Measure_Explainer_ExtraInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "Off until " }, { type: "markup-start", name: "v", options: {}, attributes: {} }, { type: "text", value: String(i?.field) }, { type: "text", value: ": true" }, { type: "markup-end", name: "v", options: {}, attributes: {} }, { type: "text", value: ", then added on top of the cap." }])
			})
		}
	)
);

const zh_hans1_measure_explainer_extra = /** @type {((inputs: Measure_Explainer_ExtraInputs) => LocalizedString) & { parts: (inputs: Measure_Explainer_ExtraInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Measure_Explainer_ExtraInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`默认关闭，设置 ${i?.field}: true 后开启，费用在封顶价之外另计。`)
		}),
		{
			parts: /** @type {(inputs: Measure_Explainer_ExtraInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "默认关闭，设置 " }, { type: "markup-start", name: "v", options: {}, attributes: {} }, { type: "text", value: String(i?.field) }, { type: "text", value: ": true" }, { type: "markup-end", name: "v", options: {}, attributes: {} }, { type: "text", value: " 后开启，费用在封顶价之外另计。" }])
			})
		}
	)
);

const pt_br2_measure_explainer_extra = /** @type {((inputs: Measure_Explainer_ExtraInputs) => LocalizedString) & { parts: (inputs: Measure_Explainer_ExtraInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Measure_Explainer_ExtraInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`Desligado até ${i?.field}: true; depois, somado por cima do teto.`)
		}),
		{
			parts: /** @type {(inputs: Measure_Explainer_ExtraInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "Desligado até " }, { type: "markup-start", name: "v", options: {}, attributes: {} }, { type: "text", value: String(i?.field) }, { type: "text", value: ": true" }, { type: "markup-end", name: "v", options: {}, attributes: {} }, { type: "text", value: "; depois, somado por cima do teto." }])
			})
		}
	)
);

const es_measure_explainer_extra = /** @type {((inputs: Measure_Explainer_ExtraInputs) => LocalizedString) & { parts: (inputs: Measure_Explainer_ExtraInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Measure_Explainer_ExtraInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`Desactivado hasta ${i?.field}: true; luego se suma por encima del tope.`)
		}),
		{
			parts: /** @type {(inputs: Measure_Explainer_ExtraInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "Desactivado hasta " }, { type: "markup-start", name: "v", options: {}, attributes: {} }, { type: "text", value: String(i?.field) }, { type: "text", value: ": true" }, { type: "markup-end", name: "v", options: {}, attributes: {} }, { type: "text", value: "; luego se suma por encima del tope." }])
			})
		}
	)
);

const fr_measure_explainer_extra = /** @type {((inputs: Measure_Explainer_ExtraInputs) => LocalizedString) & { parts: (inputs: Measure_Explainer_ExtraInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Measure_Explainer_ExtraInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`Désactivé jusqu’à ${i?.field}: true, puis ajouté en plus du plafond.`)
		}),
		{
			parts: /** @type {(inputs: Measure_Explainer_ExtraInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "Désactivé jusqu’à " }, { type: "markup-start", name: "v", options: {}, attributes: {} }, { type: "text", value: String(i?.field) }, { type: "text", value: ": true" }, { type: "markup-end", name: "v", options: {}, attributes: {} }, { type: "text", value: ", puis ajouté en plus du plafond." }])
			})
		}
	)
);

const de_measure_explainer_extra = /** @type {((inputs: Measure_Explainer_ExtraInputs) => LocalizedString) & { parts: (inputs: Measure_Explainer_ExtraInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Measure_Explainer_ExtraInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`Aus, bis ${i?.field}: true gesetzt ist, dann zusätzlich zur Obergrenze berechnet.`)
		}),
		{
			parts: /** @type {(inputs: Measure_Explainer_ExtraInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "Aus, bis " }, { type: "markup-start", name: "v", options: {}, attributes: {} }, { type: "text", value: String(i?.field) }, { type: "text", value: ": true" }, { type: "markup-end", name: "v", options: {}, attributes: {} }, { type: "text", value: " gesetzt ist, dann zusätzlich zur Obergrenze berechnet." }])
			})
		}
	)
);

const ru_measure_explainer_extra = /** @type {((inputs: Measure_Explainer_ExtraInputs) => LocalizedString) & { parts: (inputs: Measure_Explainer_ExtraInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Measure_Explainer_ExtraInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`Выключено, пока не задано ${i?.field}: true, затем добавляется сверх лимита.`)
		}),
		{
			parts: /** @type {(inputs: Measure_Explainer_ExtraInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "Выключено, пока не задано " }, { type: "markup-start", name: "v", options: {}, attributes: {} }, { type: "text", value: String(i?.field) }, { type: "text", value: ": true" }, { type: "markup-end", name: "v", options: {}, attributes: {} }, { type: "text", value: ", затем добавляется сверх лимита." }])
			})
		}
	)
);

const it_measure_explainer_extra = /** @type {((inputs: Measure_Explainer_ExtraInputs) => LocalizedString) & { parts: (inputs: Measure_Explainer_ExtraInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Measure_Explainer_ExtraInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`Disattivato finché ${i?.field}: true, poi aggiunto oltre il tetto.`)
		}),
		{
			parts: /** @type {(inputs: Measure_Explainer_ExtraInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "Disattivato finché " }, { type: "markup-start", name: "v", options: {}, attributes: {} }, { type: "text", value: String(i?.field) }, { type: "text", value: ": true" }, { type: "markup-end", name: "v", options: {}, attributes: {} }, { type: "text", value: ", poi aggiunto oltre il tetto." }])
			})
		}
	)
);

/**
* | output |
* | --- |
* | "Off until {field}: true, then added on top of the cap." |
*
* @param {Measure_Explainer_ExtraInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const measure_explainer_extra = /** @type {((inputs: Measure_Explainer_ExtraInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & { parts: (inputs: Measure_Explainer_ExtraInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => import('../runtime.js').MessagePart[] } & import('../runtime.js').MessageMetadata<Measure_Explainer_ExtraInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, { v: { options: {}; attributes: {}; children: true } }>} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Measure_Explainer_ExtraInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString} */ ((inputs, options = {}) => {
			const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
			if (locale === "zh-Hans") return zh_hans1_measure_explainer_extra(inputs)
			if (locale === "pt-BR") return pt_br2_measure_explainer_extra(inputs)
			if (locale === "es") return es_measure_explainer_extra(inputs)
			if (locale === "fr") return fr_measure_explainer_extra(inputs)
			if (locale === "de") return de_measure_explainer_extra(inputs)
			if (locale === "ru") return ru_measure_explainer_extra(inputs)
			if (locale === "it") return it_measure_explainer_extra(inputs)
			return en_measure_explainer_extra(inputs)
		}),
		{
			parts: /** @type {(inputs: Measure_Explainer_ExtraInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => import('../runtime.js').MessagePart[]} */ ((inputs, options = {}) => {
				const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
				if (locale === "zh-Hans") return typeof zh_hans1_measure_explainer_extra.parts === "function" ? zh_hans1_measure_explainer_extra.parts(inputs) : [{ type: "text", value: zh_hans1_measure_explainer_extra(inputs) }]
				if (locale === "pt-BR") return typeof pt_br2_measure_explainer_extra.parts === "function" ? pt_br2_measure_explainer_extra.parts(inputs) : [{ type: "text", value: pt_br2_measure_explainer_extra(inputs) }]
				if (locale === "es") return typeof es_measure_explainer_extra.parts === "function" ? es_measure_explainer_extra.parts(inputs) : [{ type: "text", value: es_measure_explainer_extra(inputs) }]
				if (locale === "fr") return typeof fr_measure_explainer_extra.parts === "function" ? fr_measure_explainer_extra.parts(inputs) : [{ type: "text", value: fr_measure_explainer_extra(inputs) }]
				if (locale === "de") return typeof de_measure_explainer_extra.parts === "function" ? de_measure_explainer_extra.parts(inputs) : [{ type: "text", value: de_measure_explainer_extra(inputs) }]
				if (locale === "ru") return typeof ru_measure_explainer_extra.parts === "function" ? ru_measure_explainer_extra.parts(inputs) : [{ type: "text", value: ru_measure_explainer_extra(inputs) }]
				if (locale === "it") return typeof it_measure_explainer_extra.parts === "function" ? it_measure_explainer_extra.parts(inputs) : [{ type: "text", value: it_measure_explainer_extra(inputs) }]
				return typeof en_measure_explainer_extra.parts === "function" ? en_measure_explainer_extra.parts(inputs) : [{ type: "text", value: en_measure_explainer_extra(inputs) }]
			})
		}
	)
);